/**
 * Created by lu on 2018/4/8.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view:{
        tag:'li',
        'class':'swiper-slide',
        $slot:'inner'
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/swiper/SwiperItem.js
// module id = 190
// module chunks = 6